import { getCartInfo } from "@api/getCartInfo";
import type { LineItem } from "@contexts/CartInfoContext";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch license products from getCartInfo API using useQuery.
 * Follows the same pattern as useGetDearProducts for accessories.
 */
export const useGetLicenseProducts = (skus: string[], currency: string = "usd") =>
  useQuery<LineItem[], Error>({
    queryKey: ["license-products", skus, currency],
    queryFn: async () => {
      const items = skus.map((sku) => ({ sku, quantity: 1 }));

      const response = await getCartInfo({
        params: {
          items,
          purchase_type: "new_purchase",
          currency,
        },
        authToken: null,
      });

      return response.data.items!.map((item) => ({
        sku: item.sku,
        title: item.product_title,
        description: item.product_description,
        price: item.unit_amount,
        quantity: 1,
      }));
    },
    enabled: skus.length > 0,
  });
